// EditFieldModal.js
import React, { useState, useEffect } from "react";
import { useUserInfo } from "../../../../../context/user";
import { useUpdateAccount, useUpdateChatUser } from "../../../../../queries/settingsAccount";
import { X } from "lucide-react";
import { Input } from "components/ui/input";
import { Button } from "components/ui/button";


const EditFieldModal = ({
  isOpen,
  onClose,
  field,
  label,
  user,
  updateUser,
  userActiveLocation,
}) => {
  const [value, setValue] = useState("");
  const saveActiveLocation = useUserInfo()[5]
  const updateChatUser = useUpdateChatUser();
  const updateAccount = useUpdateAccount();

  useEffect(() => {
    if (user && field) {
      setValue(user[field] || userActiveLocation[field] || "");
    }
  }, [user, field, userActiveLocation]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (user[field]) {
        const updatedData = {
          _id: user._id,
          userName: field === "userName" ? value : user.userName,
          email: field === "email" ? value : user.email,
          contactNumber: user.contactNumber,
        };

        const response = await updateChatUser.mutateAsync(updatedData);
        if (response) {
          updateUser(response?.data);
          onClose();
        }
      } else {
        const updateBusinessName = {
          _id: userActiveLocation.id,
          business_name: value,
        };

        const response = await updateAccount.mutateAsync(updateBusinessName);
        if (response) {
          saveActiveLocation({ ...userActiveLocation, business_name: value });
          onClose();
        }
      }
    } catch (error) {
      console.error("Error:", error);
      alert(`An error occurred while updating ${label.toLowerCase()}.`);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-30 flex items-center justify-center">
      <div className="bg-card rounded-lg p-6 w-full max-w-sm shadow-lg relative">
        <button
          type="button"
          aria-label="Close"
          className="absolute top-2 right-3 text-muted-foreground hover:text-foreground"
          onClick={onClose}
        >
          <X className="w-5 h-5" />
        </button>
        <h2 className="text-lg font-medium mb-4">Edit {label}</h2>
        <form onSubmit={handleSubmit}>
          <Input
            type={field === "email" ? "email" : "text"}
            placeholder={`Enter ${label}`}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className="mb-4"
          />
          <Button
            type="submit"
            className="w-full"
            disabled={!value.trim()}
          >
            Save Changes
          </Button>
        </form>
      </div>
    </div>
  );
};

export default EditFieldModal;
